import React from "react";
import { Navbar, Nav } from "react-bootstrap";
import { ButtonGroup, Button } from "react-bootstrap";
import { useContext, useState } from "react";
import { UserContext } from "../../use_context";
import { Link } from "react-router-dom";
import Offcanvas from "react-bootstrap/Offcanvas";
import { NavLink } from "react-router-dom";

import NavDropdown from "react-bootstrap/NavDropdown";
import search from "../../assets/logo (2).svg";

function Header({ onTagClick }) {
  const { workCategoryData } = useContext(UserContext);
  const [offcanvasOpen, setOffcanvasOpen] = useState(false);

  const handleOffcanvasToggle = () => {
    setOffcanvasOpen(!offcanvasOpen);
  };

  const handleOffcanvasClose = () => {
    setOffcanvasOpen(false);
  };
  return (
    <header className="wide-container text-dark  bg-white">
      <Navbar expand="lg" className="nav-row first-row">
        <Link to="/homepage" className="text-decoration-none">
          <Navbar.Brand className="brand-logo">
            <img
              src={search}
              width="178px"
              height="33px"
              alt="React Bootstrap logo"
            />
          </Navbar.Brand>
        </Link>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          onClick={handleOffcanvasToggle}
        />
        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="end"
          className="office-offcanvas-custom"
          show={offcanvasOpen}
          onHide={handleOffcanvasClose}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id="offcanvasNavbarLabel"></Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Navbar.Collapse
              id="basic-navbar-nav"
              className="justify-content-end"
            >
              <Nav className="menu list-inline custom-ml m-0 p-0" id="menu">
                {/* <NavDropdown.Item href="#action3"> */}
                <Nav.Link
                  as={Link}
                  to="/Office"
                  className={offcanvasOpen ? "white-text" : "black-text"}
                  // href="/Office"
                >
                  Office
                </Nav.Link>
                {/* </NavDropdown.Item> */}
                {/* <NavDropdown.Item href="#action3"> */}
                {/* <Link to="/works" className="text-decoration-none"> */}
                <Nav.Link
                  as={Link}
                  to="/Works"
                  className={`${
                    offcanvasOpen ? "white-text" : "black-text"
                  } active`}
                  // href="/Works"
                >
                  Works
                </Nav.Link>
                {/* </Link> */}
                {/* </NavDropdown.Item> */}
                {/* <NavDropdown.Item */}
                <Nav.Link
                  as={Link}
                  to="/news"
                  activeClassName="active"
                  className="text-decoration-none"
                >
                  News
                </Nav.Link>
                {/* </NavDropdown.Item> */}

                {/* <NavDropdown.Item href="#action3" className="active"> */}
                {/* <Link to="/contact" className="text-decoration-none"> */}
                <Nav.Link
                  as={Link}
                  to="/Contact"
                  className={offcanvasOpen ? "white-text" : "black-text"}

                  // href="/Contact"
                >
                  Contact
                </Nav.Link>
                {/* </Link> */}
                {/* </NavDropdown.Item> */}
              </Nav>
            </Navbar.Collapse>
          </Offcanvas.Body>
        </Navbar.Offcanvas>
      </Navbar>

      <div className="sub-menu-wrapper page-loaded text-end">
        <ButtonGroup className="sub-menu work-list-inline nav-links">
          {workCategoryData.map((category) => (
            <Button
              key={category.id}
              className="btn-link"
              type="button"
              onClick={() => onTagClick(category.id)}
            >
              {category.name}
            </Button>
          ))}
        </ButtonGroup>
      </div>
    </header>
  );
}

export default Header;
